<div class="container">
  <div class="icon-container">
    <span class="icon"> ⚠️ </span>
  </div>
  <p class="title">Cálculo de Juros</p>
  <mat-dialog-content class="mat-typography">
    <div class="content">
      <p>
        A partir de agora, será implementado o cálculo automático de juros e multa para operações em
        cobrança, incluindo o cálculo retroativo desde a data de vencimento até a data de inclusão
        na cobrança. Os valores padronizados serão 2% do valor de face e 0,33% de Juros de mora ao
        dia.
      </p>
      <p>
        Caso exista a necessidade de ajustar os valores mencionados acima ou tenha dúvidas sobre o
        cálculo do juros, entre em contato com nossos operadores.
      </p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button cdkFocusInitial mat-button [mat-dialog-close]="true" class="btn-primary">
      Confirmar
    </button>
  </mat-dialog-actions>
</div>
